import axios, { isAxiosError } from "axios";
import { toast } from "react-toastify";

import ErrorToast from "@/components/common/ErrorToast";
import { ErrorMessageType } from "@/types/error";

import BuildError from "./error/buildError";
import {
  DefaultErrorMessage,
  DefaultNetworkErrorMessage,
  NetworkErrorMessages,
} from "./error/message";
import NetworkError from "./error/networkError";
import PostAPI from "./post";
import UserAPI from "./user";

class API {
  post: PostAPI;
  user: UserAPI;

  constructor() {
    const BASE_URL = process.env.NEXT_PUBLIC_HOSTNAME;

    const instance = axios.create({
      baseURL: BASE_URL,
    });

    instance.interceptors.request.use(
      (config) => {
        config.url += "/";
        return config;
      },
      (error) => {
        return error;
      },
    );

    instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (typeof window === "undefined") throw new BuildError();

        let errorMessage: ErrorMessageType;

        if (isAxiosError(error)) {
          const errorStatus = error.status || error.request.status;
          if (error.status === 400) {
            errorMessage = {
              description: (
                Object.values(error?.response?.data.error)[0] as string[]
              )[0],
            };
          } else {
            errorMessage =
              NetworkErrorMessages[errorStatus] || DefaultNetworkErrorMessage;
          }
          toast.error(<ErrorToast errorMessage={errorMessage} />);
          throw new NetworkError();
        }

        toast.error(<ErrorToast errorMessage={DefaultErrorMessage} />);
        throw new Error();
      },
    );

    this.post = new PostAPI(instance, "/posts");
    this.user = new UserAPI(instance, "/users");
  }
}

const api = new API();

export default api;
